import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Ad Impact")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "h4" }, "Groups", -1)
const _hoisted_4 = {
  class: "d-flex flex-wrap mb-2",
  style: {"gap":"4px"}
}
const _hoisted_5 = {
  type: "button",
  class: "btn btn-primary badge badge-pill p-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user-edit align-middle" }, null, -1)
const _hoisted_7 = { class: "align-middle ml-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("legend", { class: "h4 mb-4" }, "Campaign info", -1)
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  id: "purchase-mode-label",
  class: "col-sm-2 col-form-label"
}, " Purchase mode ", -1)
const _hoisted_11 = { class: "col-sm-10" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "opportunity-id",
  class: "col-form-label col-sm-2"
}, "Opportunity ID", -1)
const _hoisted_14 = { class: "col-sm-10" }
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "odp-media",
  class: "col-form-label col-sm-2"
}, "ODP media", -1)
const _hoisted_17 = { class: "col-sm-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hashtag" }, null, -1)
const _hoisted_19 = { class: "ml-1" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_21 = ["onSubmit"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("legend", { class: "h4 mb-4" }, "Age brackets", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_24 = { class: "list-unstyled" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex justify-content-center text-secondary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-grip-horizontal" })
], -1)
const _hoisted_26 = { class: "h4" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Question ")
const _hoisted_28 = ["for"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("legend", { class: "d-block small text-secondary text-uppercase font-weight-bold" }, "Options", -1)
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "form-row" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Shuffle answer ")
const _hoisted_33 = { class: "form-row" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Single answer ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Update question ")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", { class: "d-block mb-0 small text-secondary text-uppercase font-weight-bold" }, " Choices ", -1)
const _hoisted_38 = { class: "list-unstyled" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_40 = { key: 1 }

import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "primevue/usetoast";
import { AgeBrackets, Brandlift } from '@/interfaces/Brandlift';
import axios from "@/api";
import AppBox from "@/components/AppBox.vue";
import Calendar from "primevue/calendar";
import CampaignFormHeader from "@/components/CampaignFormHeader.vue";
import Dropdown from "primevue/dropdown";
import FormRow from "@/components/FormRow.vue";
import TagInput from "@/components/TagInput.vue";
import { PurchaseMode } from "@/interfaces/Campaign";
import Textarea from "primevue/textarea";
import Button from "primevue/button";
import InputAgeBracket from "@/components/InputAgeBracket.vue";
import ChoiceUpdateForm from "@/components/ChoiceUpdateForm.vue";
import ChoiceAddForm from "@/components/ChoiceAddForm.vue";
import ChoiceRemoveForm from "@/components/ChoiceRemoveForm.vue";
import ActionDialog from "@/components/ActionDialog.vue";
import { Alert, useAlert } from "@/composables/alert";
import QuestionCreateForm from "@/components/QuestionCreateForm.vue";
import FormCheck from "@/components/FormCheck.vue";
import QuestionDeleteForm from "@/components/QuestionDeleteForm.vue";
import { type BroadcastGroup, type Choice, type Question, type QuestionCore } from "@/types";
import BroadcastGroupAddForm from "@/components/BroadcastGroupAddForm.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const toast = useToast();

const selectedPurchaseMode = ref<PurchaseMode | null>(null);
const studiedOdps = ref<Array<string>>([]);
const opportunityIds = ref<Array<string>>([]);

const studiedCampaigns = computed(() => {
	const mapper = (v: string) => studiedCampaignMap.get(v) ?? ({ businessId: v });
	switch (selectedPurchaseMode.value?.code) {
		case 'OTC':
			return studiedOdps.value.map(mapper);
		case 'PRG':
			return opportunityIds.value.map(mapper);
		default:
			return [];
	}
});

const questionnaireContext = ref<Brandlift | null>(null);

const formData = ref<Brandlift>({
	campaign: {
		odp: '',
		purchaseMode: selectedPurchaseMode,
		advertiser: '',
		name: '',
		dateStart: '',
		dateEnd: ''
	},
	studiedCampaigns: studiedCampaigns,
	questions: [],
});

const ageBrackets = ref<AgeBrackets>([]);

let studiedCampaignMap = new Map<string, string>();

function hydrateCampaignInfo(data: Brandlift): void {
	formData.value.campaign.odp = data.campaign.odp;
	formData.value.campaign.advertiser = data.campaign.advertiser;
	formData.value.campaign.name = data.campaign.name;
	formData.value.campaign.dateStart = new Date(data.campaign.dateStart);
	formData.value.campaign.dateEnd = new Date(data.campaign.dateEnd);

	selectedPurchaseMode.value = data.campaign.purchaseMode;

	const businessIds = data.studiedCampaigns.map(v => v.businessId);
	switch (data.campaign.purchaseMode.code) {
		case 'OTC':
			studiedOdps.value = businessIds;
			break;
		case 'PRG':
			opportunityIds.value = businessIds;
			break;
	}

	studiedCampaignMap.clear();
	for (const s of data.studiedCampaigns) {
		studiedCampaignMap.set(s.businessId, s['@id']);
	}

	ageBrackets.value = data.studiedAgeBrackets;
}

let purchaseModes = ref<Array<{}>>([]);
const httpRoute = `/campaigns/brandlifts/${route.params.id}`;

onMounted(() => {
	axios.get('/purchase_modes').then(res => {
		purchaseModes.value = res.data['hydra:member'];
	});

	axios.get(httpRoute)
		.then(({ data }: { data: Brandlift }): void => {
			questionnaireContext.value = data;
			hydrateCampaignInfo(data);
			formData.value.questions = data.questions;
		});
});

function submit(): void {
	toast.removeAllGroups();

	const payload: Brandlift = {
		...formData.value,
		campaign: {
			...formData.value.campaign,
			purchaseMode: selectedPurchaseMode.value['@id']
		}
	};

	axios
		.put(httpRoute, payload)
		.then(({ data }) => {
			hydrateCampaignInfo(data);
			toast.add({
				severity: "success",
				summary: "Campaign updated",
				life: 3000,
			});
		})
		.catch(err => {
			toast.add({
				severity: "error",
				summary: err.response.data["hydra:title"],
				detail: err.response.data["hydra:description"]
			});
		});
}

function updateQuestion(q: Question): void {
	const payload: QuestionCore = {
		ordinal: q.ordinal,
		title: q.title,
		isSingleAnswer: q.isSingleAnswer,
		isShuffledAnswers: q.isShuffledAnswers,
	};

	axios
		.put(`/questions/${q.uuid}`, payload)
		.then(() => {
			showFeedbackDialog({
				status: 'success',
				summary: 'La question a été mise à jour avec succès',
			});
		})
		.catch(({ response }) => {
			showFeedbackDialog({
				status: (409 === response.status) ? 'conflict' : 'error',
				detail: (409 === response.status) ? response.data['hydra:description'] : undefined
			});
		});
}

function onQuestionCreated(q: Question): void {
	formData.value.questions.push({
		id: q.id,
		uuid: q.uuid,
		ordinal: q.ordinal,
		title: q.title,
		isSingleAnswer: q.isSingleAnswer,
		isShuffledAnswers: q.isShuffledAnswers,
		choices: q.choices,
	});
}

function onQuestionDeleted(i: number): void {
	const ordinal = formData.value.questions[i].ordinal;
	formData.value.questions.splice(i, 1);
	formData.value.questions.forEach(q => {
		if (q.ordinal > ordinal) {
			q.ordinal--;
		}
	});
}

function onChoiceUpdated(source: Choice, newValue: Choice): void {
	source.name = newValue.name;
	source.isNone = newValue.isNone;
}

function onChoiceDeleted(question: Question, choice: Choice): void {
	const choiceIndex = question.choices.findIndex(c => c.id === choice.id);
	if (choiceIndex > -1) {
		question.choices.splice(choiceIndex, 1);
	}
}

function onChoiceCreated(question: Question, newChoice: Choice): void {
	question.choices.push(newChoice);
}

function onPurchaseModeChange(): void {
	switch (formData.value.campaign.purchaseMode?.code) {
		case 'OTC':
			opportunityIds.value = [];
			break;
		case 'PRG':
			studiedOdps.value = [];
			break;
		default:
			studiedOdps.value = [];
			opportunityIds.value = [];
			break;
	}
}

const feedbackAlert = useAlert();
const feedbackDialogVisible = ref(false);
function showFeedbackDialog(alert: Alert): void {
	feedbackDialogVisible.value = true;
	feedbackAlert.value = alert;
}

function onFeedbackDialogHide(): void
{
	feedbackAlert.value = null;
}

function onBroadcastGroupCreated(group: BroadcastGroup): void {
	questionnaireContext.value.campaign.targetGroups.push(group);
}

function onAgeBracketSubmit(): void {
	axios
		.put(`/campaigns/brandlifts/${questionnaireContext.value.campaign.uuid}/age-brackets`, {
			studiedAgeBrackets: ageBrackets.value
		})
		.then(() => {
			toast.add({
				severity: 'success',
				summary: 'Age brackets updated',
				life: 3000,
			});
		})
		.catch(err => {
			toast.add({
				severity: 'error',
				summary: err.response.data['hydra:title'],
				detail: err.response.data['hydra:description']
			});
		});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CampaignFormHeader, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    (questionnaireContext.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AppBox, {
            component: "section",
            class: "mb-2"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionnaireContext.value.campaign.targetGroups, (group) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: group.uuid
                  }, [
                    _createElementVNode("form", null, [
                      _createElementVNode("button", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("span", _hoisted_7, _toDisplayString(group.name), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode(BroadcastGroupAddForm, {
                "campaign-id": questionnaireContext.value.campaign.uuid,
                onCreated: onBroadcastGroupCreated
              }, null, 8, ["campaign-id"])
            ]),
            _: 1
          }),
          _createVNode(AppBox, {
            component: "section",
            class: "mb-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
                onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, [
                _createElementVNode("fieldset", null, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(Dropdown), {
                        "aria-labelledby": "purchase-mode-label",
                        modelValue: selectedPurchaseMode.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPurchaseMode).value = $event)),
                        options: _unref(purchaseModes),
                        "option-label": "label",
                        loading: 0 === _unref(purchaseModes).length,
                        placeholder: "Select purchase mode...",
                        class: "form-control",
                        onChange: onPurchaseModeChange
                      }, null, 8, ["modelValue", "options", "loading"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(TagInput, {
                        "input-id": "opportunity-id",
                        modelValue: opportunityIds.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((opportunityIds).value = $event)),
                        "displayed-key": ['opportunityId'],
                        disabled: 'PRG' !== selectedPurchaseMode.value?.code,
                        "add-on-blur": "",
                        "item-class": "badge-dark rounded-pill"
                      }, null, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(TagInput, {
                        "input-id": "odp-media",
                        modelValue: studiedOdps.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((studiedOdps).value = $event)),
                        disabled: 'OTC' !== selectedPurchaseMode.value?.code,
                        "add-on-blur": "",
                        "item-class": "badge-dark rounded-pill"
                      }, {
                        item: _withCtx(({ item }) => [
                          _hoisted_18,
                          _createElementVNode("span", _hoisted_19, _toDisplayString(item), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createVNode(FormRow, {
                    label: "ODP questionnaire",
                    modelValue: formData.value.campaign.odp,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.campaign.odp) = $event)),
                    modelModifiers: { trim: true }
                  }, null, 8, ["modelValue"]),
                  _createVNode(FormRow, {
                    label: "Advertiser",
                    modelValue: formData.value.campaign.advertiser,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.campaign.advertiser) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(FormRow, {
                    label: "Campaign name",
                    modelValue: formData.value.campaign.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.campaign.name) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(FormRow, { label: "Date start" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Calendar), {
                        "aria-label": "Date start",
                        modelValue: formData.value.campaign.dateStart,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.campaign.dateStart) = $event)),
                        "date-format": "dd/mm/yy",
                        class: "w-100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(FormRow, { label: "Date end" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Calendar), {
                        "aria-label": "Date end",
                        modelValue: formData.value.campaign.dateEnd,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.campaign.dateEnd) = $event)),
                        "date-format": "dd/mm/yy",
                        class: "w-100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    onClick: submit,
                    class: "d-block ml-auto"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ])
              ], 32)
            ]),
            _: 1
          }),
          _createVNode(AppBox, {
            component: "section",
            class: "mb-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                onSubmit: _withModifiers(onAgeBracketSubmit, ["prevent"]),
                onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, [
                _createElementVNode("fieldset", null, [
                  _hoisted_22,
                  _createVNode(InputAgeBracket, {
                    modelValue: ageBrackets.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ageBrackets).value = $event)),
                    class: "mb-4"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(Button), {
                    type: "submit",
                    class: "d-block ml-auto"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  })
                ])
              ], 40, _hoisted_21)
            ]),
            _: 1
          }),
          _createElementVNode("ol", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.questions, (question, questionIndex) => {
              return (_openBlock(), _createBlock(AppBox, {
                component: "li",
                key: question.uuid,
                class: "mb-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_25,
                  _createElementVNode("article", null, [
                    _createElementVNode("h2", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("span", null, _toDisplayString(question.ordinal), 1)
                    ]),
                    _createElementVNode("form", null, [
                      _createElementVNode("label", {
                        for: `question-title-${question.ordinal}`,
                        class: "small text-secondary text-uppercase font-weight-bold"
                      }, " Title ", 8, _hoisted_28),
                      _createVNode(_unref(Textarea), {
                        modelValue: question.title,
                        "onUpdate:modelValue": ($event: any) => ((question.title) = $event),
                        "auto-resize": "",
                        id: `question-title-${question.ordinal}`,
                        class: "d-block w-100 mb-2"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "id"]),
                      _createElementVNode("fieldset", null, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(FormCheck, {
                              modelValue: question.isShuffledAnswers,
                              "onUpdate:modelValue": ($event: any) => ((question.isShuffledAnswers) = $event)
                            }, {
                              default: _withCtx(() => [
                                _hoisted_32
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(FormCheck, {
                              modelValue: question.isSingleAnswer,
                              "onUpdate:modelValue": ($event: any) => ((question.isSingleAnswer) = $event)
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ])
                      ]),
                      _createVNode(_unref(Button), {
                        disabled: question.title.trim() === '',
                        onClick: ($event: any) => (updateQuestion(question)),
                        class: "d-block ml-auto"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_35
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ]),
                    _hoisted_36,
                    _createElementVNode("section", null, [
                      _hoisted_37,
                      _createElementVNode("ol", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.choices, (choice) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `choice-${choice.id}`,
                            class: "row align-items-center"
                          }, [
                            _createVNode(ChoiceUpdateForm, {
                              "initial-state": choice,
                              "campaign-id": questionnaireContext.value.campaign.uuid,
                              onUpdate: ($event: any) => (onChoiceUpdated(choice, $event))
                            }, null, 8, ["initial-state", "campaign-id", "onUpdate"]),
                            _createVNode(ChoiceRemoveForm, {
                              choice: choice,
                              "campaign-id": questionnaireContext.value.campaign.uuid,
                              onRemove: ($event: any) => (onChoiceDeleted(question, choice))
                            }, null, 8, ["choice", "campaign-id", "onRemove"])
                          ]))
                        }), 128))
                      ]),
                      _createVNode(ChoiceAddForm, {
                        question: question,
                        "campaign-id": questionnaireContext.value.campaign.uuid,
                        onCreated: ($event: any) => (onChoiceCreated(question, $event))
                      }, null, 8, ["question", "campaign-id", "onCreated"])
                    ]),
                    _hoisted_39,
                    _createVNode(QuestionDeleteForm, {
                      question: question,
                      "campaign-id": questionnaireContext.value.campaign.uuid,
                      onRemove: ($event: any) => (onQuestionDeleted(questionIndex))
                    }, null, 8, ["question", "campaign-id", "onRemove"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createElementVNode("li", null, [
              _createVNode(AppBox, null, {
                default: _withCtx(() => [
                  _createVNode(QuestionCreateForm, {
                    ordinal: 1 + formData.value.questions.length,
                    "campaign-id": questionnaireContext.value.campaign.uuid,
                    onCreated: _cache[12] || (_cache[12] = ($event: any) => (onQuestionCreated($event)))
                  }, null, 8, ["ordinal", "campaign-id"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(ActionDialog, {
            visible: feedbackDialogVisible.value,
            "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((feedbackDialogVisible).value = $event)),
            alert: _unref(feedbackAlert),
            "campaign-id": questionnaireContext.value.campaign.uuid,
            onHide: onFeedbackDialogHide
          }, null, 8, ["visible", "alert", "campaign-id"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_40, " Loading... "))
  ]))
}
}

})